// extracted by mini-css-extract-plugin
module.exports = {"root":"PaymentsMobile_root__2nkY_","item":"PaymentsMobile_item__2U1vr","label":"PaymentsMobile_label__TxkjD","amount":"PaymentsMobile_amount__XwD7G"};